import TwinIcon, { TwinIconProp } from '../../TwinIcon'
import TwinToolTip from '../../TwinToolTip'

interface DisplayStatusProps {
    icon: TwinIconProp
    text: string
    colorText: string
}

export const DisplayStatus: React.FC<DisplayStatusProps> = ({ icon, text, colorText }) => {
    return (
        <div className={'flex items-center justify-center border rounded-5 px-10 py-4 text-center ' + colorText}>
            <TwinIcon className='mr-5' icon={icon} size='lg' />
            {text}
        </div>
    )
}

interface DisplayStatusWithoutIconProps {
    text: string
    colorText: string
    className?: string
}

export const DisplayStatusWithoutIcon: React.FC<DisplayStatusWithoutIconProps> = ({ text, colorText, className }) => {
    return (
        <div className={'flex items-center justify-center border rounded-5 px-10 py-4 text-center ' + colorText + ' ' + className || ''} style={{color: colorText}}>
            {text}
        </div>
    )
}
interface DisplayStatusToolTipProps {
    text: string
    colorText: string
    className?: string
    idTooltip: string
}

export const DisplayStatusToolTip: React.FC<DisplayStatusToolTipProps> = ({ text, colorText, className, idTooltip }) => {
    return (
        <div className={'flex items-center justify-center border rounded-5 px-10 py-4 text-center ' + colorText + ' ' + className || ''} style={{color: colorText}}>
            <div className='twin_elipsis' id={idTooltip}>
                {text}
                <TwinToolTip place='top' anchorSelect={'#' + idTooltip} className='twin_elipsis' positionStrategy='fixed' content={text} />
            </div>
        </div>
    )
}
